let tooltip!: HTMLElement;

/**
 * Creates a tooltip and shows it on the given element.
 * @param element The element to attach the tooltip to.
 * @param content The content to display (string = plain text, function returning
 *                string = HTML rich content evaluated at hover time).
 */
function showTooltip(element: HTMLElement, content: string | (() => string), rich = false) {
    tooltip ??= document.createElement('div');

    let rect = element.getBoundingClientRect();

    tooltip.classList.add('bubble');

    if (rich) {
        let html = typeof content === 'function' ? content() : content;
        if (!html) return;
        tooltip.innerHTML = html;
        tooltip.classList.add('bubble-rich');
    } else {
        tooltip.textContent = typeof content === 'function' ? content() : content;
        tooltip.classList.remove('bubble-rich');
    }

    document.querySelector('#bubbles')!.append(tooltip);

    tooltip.style.padding = '5px 10px';
    tooltip.style.left = `${rect.left + rect.width / 2 - tooltip.offsetWidth / 2}px`;
    tooltip.style.top = `${rect.top - tooltip.offsetHeight}px`;

    element.addEventListener('blur', () => tooltip.remove());
    element.addEventListener('mouseout', () => tooltip.remove());
    element.addEventListener('mouseleave', () => tooltip.remove());

    element.addEventListener('touchend', (event) => {
        if (event.target !== element) tooltip.remove();
    });
    element.addEventListener('touchcancel', (event) => {
        if (event.target !== element) tooltip.remove();
    });

    document.addEventListener('touchend', (event) => {
        if (event.target !== element) tooltip.remove();
    });
    document.addEventListener('touchcancel', (event) => {
        if (event.target !== element) tooltip.remove();
    });
}

/**
 * Listens for events on the given element and shows a tooltip when the event is triggered.
 */

export function attachTooltip(element: HTMLElement, text: string): void {
    element.addEventListener('focus', () => showTooltip(element, text));
    element.addEventListener('mouseover', () => showTooltip(element, text));
    element.addEventListener('mouseenter', () => showTooltip(element, text));
    element.addEventListener('touchstart', () => showTooltip(element, text));
}

/**
 * Same as attachTooltip but content is generated on-demand (lets slots update
 * their stats/enchantments between hovers without re-binding) and rendered as
 * HTML for stat + enchantment tables. Return an empty string to suppress.
 */

export function attachRichTooltip(element: HTMLElement, getHtml: () => string): void {
    let show = () => showTooltip(element, getHtml, true);
    element.addEventListener('focus', show);
    element.addEventListener('mouseover', show);
    element.addEventListener('mouseenter', show);
    element.addEventListener('touchstart', show);
}
